import React, { Component } from 'react'

import {
  Switch,
  Route
} from 'react-router-dom'

import Config from '../Config'
import WindowUtil from '../common/Window'
import NaviBar from './components/NaviBar'
import NaviIconMenu from './components/NaviIconMenu'
import Footer from '../common/component/Footer'
import Login from './pages/public/Login'
import PasswordReset from './pages/public/PasswordReset'
import Dashboard from './pages/secure/Dashboard'
import InformationList from './pages/secure/InformationList'
import InformationEdit from './pages/secure/InformationEdit'
import InformationDetail from './pages/secure/InformationDetail'
import SharedFileList from './pages/secure/SharedFileList'
import SharedFileEdit from './pages/secure/SharedFileEdit'
import SharedFileDetail from './pages/secure/SharedFileDetail'

import RoutineTaskHome from './pages/secure/RoutineTaskHome'
import SystemSettingHome from './pages/secure/SystemSettingHome'

import SurveySettingHome from './pages/secure/SurveySettingHome'
import SurveySettingList from './pages/secure/SurveySettingList'
import SurveySettingEdit from './pages/secure/SurveySettingEdit'
import SurveyBigQuestionList from './pages/secure/SurveyBigQuestionList'
import SurveyMediumQuestionList from './pages/secure/SurveyMediumQuestionList'
import SurveySmallQuestionList from './pages/secure/SurveySmallQuestionList'
import SurveyBigQuestionEdit from './pages/secure/SurveyBigQuestionEdit'
import SurveyMediumQuestionEdit from './pages/secure/SurveyMediumQuestionEdit'
import SurveySmallQuestionEdit from './pages/secure/SurveySmallQuestionEdit'

import PersonalSettingHome from './pages/secure/PersonalSettingHome'
import PasswordChange from './pages/secure/PasswordChange'
import EmailChange from './pages/secure/EmailChange'
import NotificationSettingChange from './pages/secure/NotificationSettingChange'

import CompanyList from './pages/secure/CompanyList'
import CompanyEdit from './pages/secure/CompanyEdit'
import CompanyDetail from './pages/secure/CompanyDetail'

import CompanyUserEdit from './pages/secure/CompanyUserEdit'
import CompanyUserDetail from './pages/secure/CompanyUserDetail'

import DefaultSetting from './pages/secure/DefaultSetting'

import AdminUserList from './pages/secure/AdminUserList'
import AdminUserEdit from './pages/secure/AdminUserEdit'
import AdminUserDetail from './pages/secure/AdminUserDetail'

import PrefectureTotal from './pages/secure/PrefectureTotal'

import AWSAPI from '../common/AWSAPI'

// 強制ログアウト設定（本番：120分 開発：30分）
const TOTAL_INACTIVITY_TIMEOUT = Config.sessionTimeout.total
// 警告表示開始時間（本番：10分前 開発：5分前）
const ALERT_DELAY = Config.sessionTimeout.alertDelay
// 警告表示までの時間（本番：110分 開発：25分）
const WARNING_TIMEOUT = TOTAL_INACTIVITY_TIMEOUT - ALERT_DELAY

class AdminApp extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isAlertVisible: false,
      remainingTime: ALERT_DELAY
    }

    this.alertTimeoutId = null
    this.countdownIntervalId = null

    this.handleUserActivity = this.handleUserActivity.bind(this)
    this.startTimers = this.startTimers.bind(this)
    this.resetTimers = this.resetTimers.bind(this)
    this.showAlert = this.showAlert.bind(this)
    this.forceLogout = this.forceLogout.bind(this)
    this.keepSessionAlive = this.keepSessionAlive.bind(this)
    this.formatTime = this.formatTime.bind(this)
  }

  componentDidMount() {
    // ログイン状態を確認しタイマーを開始
    this.startTimers()
  }

  componentWillUnmount() {
    this.clearTimers()
  }

  // タイマーを全てクリアする
  clearTimers() {
    clearTimeout(this.alertTimeoutId)
    clearInterval(this.countdownIntervalId)
  }

  // 警告表示までのタイマーを開始する
  startTimers() {
    this.clearTimers()
    if (AWSAPI.isLoggedIn('admin')) {
      // ログイン済みの場合のみタイマーを設定 (110分後に showAlert を実行)
      this.alertTimeoutId = setTimeout(this.showAlert, WARNING_TIMEOUT)
    }
  }

  // タイマーをリセットする (ユーザーアクティビティ発生時)
  resetTimers() {
    // 警告が表示中の場合は非表示にする
    if (this.state.isAlertVisible) {
      this.setState({ isAlertVisible: false })
    }
    this.setState({ remainingTime: ALERT_DELAY })
    this.clearTimers()
    this.startTimers()
  }

  // ユーザーアクティビティ検出時の処理
  handleUserActivity() {
    // ログイン済みの場合のみタイマーをリセット
    if (AWSAPI.isLoggedIn('admin')) {
      this.resetTimers()
    }
  }
  
  // 警告アラートを表示する (110分経過後)
  showAlert() {
    this.clearTimers()
    this.setState({ 
      isAlertVisible: true,
      remainingTime: ALERT_DELAY
    })

    const initialMessage = `セキュリティ保持のため、あと ${this.formatTime(ALERT_DELAY)} で自動的にログアウトされます。\n作業中の場合は保存を完了させてください。`
    WindowUtil.setDialogState({
      type: 'alert',
      message: initialMessage,
      onOKButtonClicked: this.keepSessionAlive,
      isOpen: true
    })

    // ログアウトまでのカウントダウンを開始 (1秒ごと)
    this.countdownIntervalId = setInterval(() => {
      this.setState((prevState) => {
        const newRemainingTime = prevState.remainingTime - 1000
        if (newRemainingTime < 1000) {
          clearInterval(this.countdownIntervalId)
          this.forceLogout() // 強制ログアウト処理を呼び出す
          return { remainingTime: 0 }
        }
        const updatedMessage = `セキュリティ保持のため、あと ${this.formatTime(newRemainingTime)} で自動的にログアウトされます。\n作業中の場合は保存を完了させてください。`

        // WindowUtil の状態を更新 (他のプロパティも引き継ぐ)
        const currentDialogState = WindowUtil.getDialogState()
        WindowUtil.setDialogState({
            ...currentDialogState,
            message: updatedMessage
        })

        return { remainingTime: newRemainingTime }
      })
    }, 1000)
  }

  // 「OK」ボタンを押したときの処理
  keepSessionAlive() {
    WindowUtil.closeDialog()
    // アラートを非表示にし、タイマーをリセット
    this.setState({ isAlertVisible: false })
    this.resetTimers()
  }

  handleFinalLogout() {
    AWSAPI.logout('admin')
    // 画面リロード（ログイン画面へ遷移）
    window.location.reload()
  }

  // 強制ログアウト処理
  forceLogout() {
    this.clearTimers()
    // 警告ダイアログ（カウントダウン中）を閉じる
    WindowUtil.closeDialog()

    const logoutMessage = 'セッションの有効期限が切れました。安全のため自動的にログアウトしました。'
    WindowUtil.setDialogState({
      type: 'alert',
      message: logoutMessage,
      // OKボタンクリック時に handleFinalLogout を実行する
      onOKButtonClicked: this.handleFinalLogout, 
      isOpen: true
    })
    
  }

  // ミリ秒を「N分NN秒」形式に整形するヘルパー関数
  formatTime(ms) {
    const totalSeconds = Math.floor(ms / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}分${('0' + seconds).slice(-2)}秒`
  }

  renderPublicPages () {
    return (
      <div>
        <Switch>
          <Route exact path='/admin/password_reset' component={PasswordReset} />
          <Route exact path='/admin/login' component={Login} />
          <Route component={Login} />
        </Switch>
      </div>
    )
  }
  renderSecurePages () {
    return (
      <div>
        <NaviBar history={this.props.history} />
        <div id='body-container'>
          <div id='body-content'>
            <NaviIconMenu history={this.props.history} />
            <Switch>
              <Route exact path='/admin/information' component={InformationList} />
              <Route exact path='/admin/information/add' component={InformationEdit} />
              <Route exact path='/admin/information/edit/:id' component={InformationEdit} />
              <Route exact path='/admin/information/detail/:id' component={InformationDetail} />

              <Route exact path='/admin/shared_files' component={SharedFileList} />
              <Route exact path='/admin/shared_files/add' component={SharedFileEdit} />
              <Route exact path='/admin/shared_files/edit/:id' component={SharedFileEdit} />
              <Route exact path='/admin/shared_files/detail/:id' component={SharedFileDetail} />

              <Route exact path='/admin/routine_task_home' component={RoutineTaskHome} />
              <Route exact path='/admin/system_setting_home' component={SystemSettingHome} />

              <Route exact path='/admin/survey_setting_home' component={SurveySettingHome} />
              <Route exact path='/admin/survey_setting' component={SurveySettingList} />
              <Route exact path='/admin/survey_setting/add' component={SurveySettingEdit} />
              <Route exact path='/admin/survey_setting/edit/:id' component={SurveySettingEdit} />
              <Route exact path='/admin/survey_bigquestion' component={SurveyBigQuestionList} />
              <Route exact path='/admin/survey_bigquestion/add' component={SurveyBigQuestionEdit} />
              <Route exact path='/admin/survey_bigquestion/edit/:id' component={SurveyBigQuestionEdit} />
              <Route exact path='/admin/survey_mediumquestion/:id' component={SurveyMediumQuestionList} />
              <Route exact path='/admin/survey_mediumquestion/add/:id' component={SurveyMediumQuestionEdit} />
              <Route exact path='/admin/survey_mediumquestion/edit/:id' component={SurveyMediumQuestionEdit} />
              <Route exact path='/admin/survey_smallquestion/:id' component={SurveySmallQuestionList} />
              <Route exact path='/admin/survey_smallquestion/add/:id' component={SurveySmallQuestionEdit} />
              <Route exact path='/admin/survey_smallquestion/edit/:id' component={SurveySmallQuestionEdit} />

              <Route exact path='/admin/personal_setting_home' component={PersonalSettingHome} />
              <Route exact path='/admin/password_change' component={PasswordChange} />
              <Route exact path='/admin/email_change' component={EmailChange} />
              <Route exact path='/admin/notification_setting_change' component={NotificationSettingChange} />

              <Route exact path='/admin/default_setting' component={DefaultSetting} />

              <Route exact path='/admin/admin_user' component={AdminUserList} />
              <Route exact path='/admin/admin_user/add' component={AdminUserEdit} />
              <Route exact path='/admin/admin_user/edit/:id' component={AdminUserEdit} />
              <Route exact path='/admin/admin_user/detail/:id' component={AdminUserDetail} />

              <Route exact path='/admin/company' component={CompanyList} />
              <Route exact path='/admin/company/add' component={CompanyEdit} />
              <Route exact path='/admin/company/edit/:id' component={CompanyEdit} />
              <Route exact path='/admin/company/detail/:id' component={CompanyDetail} />

              <Route exact path='/admin/company_user/add/:parentID' component={CompanyUserEdit} />
              <Route exact path='/admin/company_user/edit/:parentID/:id' component={CompanyUserEdit} />
              <Route exact path='/admin/company_user/detail/:parentID/:id' component={CompanyUserDetail} />

              <Route exact path='/admin/prefecture_total' component={PrefectureTotal} />
              <Route component={Dashboard} />
            </Switch>
          </div>
        </div>
        <Footer />
      </div>
    )
  }

  render () {
    let view = null
    if (AWSAPI.isLoggedIn('admin')) {
      view = this.renderSecurePages()
    } else {
      view = this.renderPublicPages()
    }
    return view
  }
}

export default AdminApp



// WEBPACK FOOTER //
// ./src/admin/AdminApp.js